import { render, staticRenderFns } from "./The7Seas.vue?vue&type=template&id=220b96f4"
import script from "./The7Seas.vue?vue&type=script&lang=js"
export * from "./The7Seas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports